import React from "react";

/**
 * Horizontal bar render of sessions by device. Input from
 * aggregator.engagement.by_device_current: [{ device, sessions, engagement_rate_pct }].
 */
export default function DeviceBreakdown({ rows, mode = "client" }) {
  if (!rows || rows.length === 0) return <div className="empty">No device data.</div>;
  const total = rows.reduce((a, r) => a + (r.sessions || 0), 0);
  return (
    <div className="device-rows">
      {rows.map((r) => {
        const pct = total ? (r.sessions / total) * 100 : 0;
        return (
          <div className="device-row" key={r.device}>
            <div className="device-name">{r.device}</div>
            <div className="device-track">
              <div className="device-fill" style={{ width: `${pct}%` }} />
            </div>
            <div className="device-figs">
              <strong>{r.sessions.toLocaleString()}</strong>
              <span className="subtle"> ({pct.toFixed(0)}%{mode === "agency" ? `, ${r.engagement_rate_pct.toFixed(0)}% engaged` : ""})</span>
            </div>
          </div>
        );
      })}
    </div>
  );
}
